export default __webpack_public_path__ + "static/media/KK_E_Right_Top_sCrop.72f76fac.svg";